import React from 'react';

export const TUTORIAL_STEPS = [
	{
		title: 'Create a workflow',
		steps: [
			{
				title: 'Guiding Tutorial',
				content: (
					<>
						Follow Next Steps to design a workflow using tasks
					</>
				),
				hotspotId: 'start-tutorial',
			},
			{
				title: 'List of tasks',
				content: (
					<>
						Drag a task from the list of Task Types below and drop it to the middle of the canvas to add the task in workflow. The below list of tasks are generated on the basis of Domains selected in the Create/Edit Workflow which is step 1.
					</>
				),
				hotspotId: 'draggable-tasks-list',
			},
			{
				title: 'Drop Tasks in Canvas',
				content: 'Drag a task from Task Type List and drop here to add those tasks to the workflow. Later click it to add information to the task.',
				hotspotId: 'drag-and-drop-box',
			},
			{
				title: 'Add Task Related Information',
				content:
					'Add the information given in the form and finally Save it.',
				hotspotId: 'fill-task-definition',
			},
		],
	},
];

export const TUTORIAL_CONFIG = {
	title: 'Create a workflow',
	description: 'Learn how to create a workflow using tasks',
	completedScreenDescription: 'You have completed the tutorial',
	tasks: TUTORIAL_STEPS,
};

export const TUTORIAL_I18N_STRINGS = {
	stepCounterText: (stepIndex: number, totalStepCount: number) =>
		`Step ${stepIndex + 1}/${totalStepCount}`,
	taskTitle: (taskIndex: number, taskTitle: string) =>
		`Task ${taskIndex + 1}: ${taskTitle}`,
	labelHotspot: (
		openState: boolean,
		stepIndex: number,
		totalStepCount: number
	) =>
		openState
			? `close annotation for step ${stepIndex + 1} of ${totalStepCount}`
			: `open annotation for step ${stepIndex + 1} of ${totalStepCount}`,
	nextButtonText: 'Next',
	previousButtonText: 'Previous',
	finishButtonText: 'Finish',
	labelDismissAnnotation: 'dismiss annotation',
};
